module.exports = __webpack_public_path__ + "static/media/10-d-calendar.180fcd8c.png";